// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__GOkDr","row":"styles_row__3Lnpo"};